if (!customElements.get('smooth-scroll-nav')) {
  class SmoothScrollNav extends HTMLElement {
    connectedCallback() {
      this.addEventListeners();
      this.elementsToObserve = Array.from(this.querySelectorAll("a.scroll-anchor")).map((linkElement) => 
        document.querySelector(linkElement.getAttribute("href"))
      );
      this.navListItems = Array.from(this.querySelectorAll("li"));
      window.addEventListener("scroll", this.markVisibleSection.bind(this));
      window.addEventListener("resize", this.markVisibleSection.bind(this));
      this.markVisibleSection();
    }

    addEventListeners() {
      const links = this.querySelectorAll('a.scroll-anchor');
      links.forEach(link => {
        link.addEventListener('click', this.handleClick);
      });
    }

    handleClick(e) {
      e.preventDefault();
      const targetId = e.currentTarget.getAttribute('href').slice(1);
      const targetElement = document.getElementById(targetId);
      const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;

      if (targetElement) {
        const currentUrl = window.location.href.split('#')[0];
        history.pushState(null, '', currentUrl);
        const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - headerHeight - 16;
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    }

    markVisibleSection() {
      this.navListItems.forEach((item) => item.classList.remove("is-visible"));
      for (const [index, elementToObserve] of this.elementsToObserve.entries()) {
        const boundingClientRect = elementToObserve.getBoundingClientRect();
        if (boundingClientRect.top <= window.innerHeight && boundingClientRect.bottom >= 0) {
          this.querySelector(`a[href="#${elementToObserve.id}"]`).parentElement.classList.add("is-visible");
          break;
        }
      }
    }
  }

  customElements.define('smooth-scroll-nav', SmoothScrollNav);
}


// FAQ Accordion - Only one open at a time with smooth animation
document.addEventListener("DOMContentLoaded", function () {
  const accordionDetails = document.querySelectorAll(".accordion details");

  accordionDetails.forEach(function (details) {
    const content = details.querySelector(".collapsible__content");

    // Set initial styles for animation
    if (content) {
      content.style.transition = "max-height 0.3s ease, opacity 0.3s ease";
      content.style.overflow = "hidden";

      if (!details.open) {
        content.style.maxHeight = "0px";
        content.style.opacity = "0";
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
        content.style.opacity = "1";
      }
    }

    details.addEventListener("toggle", function () {
      const currentContent = this.querySelector(".collapsible__content");

      if (this.open) {
        // Close all other accordion items with animation
        accordionDetails.forEach(function (otherDetails) {
          if (otherDetails !== details && otherDetails.open) {
            const otherContent = otherDetails.querySelector(
              ".collapsible__content"
            );

            if (otherContent) {
              // Animate close
              otherContent.style.maxHeight = "0px";
              otherContent.style.opacity = "0";

              // Close after animation
              setTimeout(function () {
                otherDetails.open = false;
                otherDetails.classList.remove("is-open");
              }, 300);
            } else {
              otherDetails.open = false;
              otherDetails.classList.remove("is-open");
            }
          }
        });

        // Animate open current accordion
        if (currentContent) {
          currentContent.style.maxHeight = currentContent.scrollHeight + "px";
          currentContent.style.opacity = "1";
        }
        this.classList.add("is-open");
      } else {
        // Animate close current accordion
        if (currentContent) {
          currentContent.style.maxHeight = "0px";
          currentContent.style.opacity = "0";
        }
        this.classList.remove("is-open");
      }
    });
  });
});